import {createSelector} from 'reselect'
import selectorsGenerator from '../hierarchyAssignmentsPanelTab/selectorsGenerator'
import {showEditor} from '../workAssignmentsEditor/selectors'
import {getManagementAssignmentsSelection as getUserDataManagementAssignmentsSelection} from '../../../panels/user/userData/selectors'
import {arrayToMap} from '../../../atUtils'
import {ManagementAssignmentsSelection} from 'constants'
import {canAccessAllManagementScope, canAccessManagersScope} from '../../../util/accessRightsUtils'

const getEditManagementAssignmentsPanelState = state => state.userManagement.editManagementAssignmentsPanel
const hierarchyAssignmentsPanelTabSelectors = selectorsGenerator(getEditManagementAssignmentsPanelState)

export const getUserId = hierarchyAssignmentsPanelTabSelectors.getUserId

export const getTab = hierarchyAssignmentsPanelTabSelectors.getTab

export const getTaskIds = hierarchyAssignmentsPanelTabSelectors.getTaskIds

export const getProjectIds = hierarchyAssignmentsPanelTabSelectors.getProjectIds

export const getSearch = hierarchyAssignmentsPanelTabSelectors.getSearch

export const isSearchOpen = hierarchyAssignmentsPanelTabSelectors.isSearchOpen

export const loadedTabs = hierarchyAssignmentsPanelTabSelectors.getLoadedTabs

export const getCounters = hierarchyAssignmentsPanelTabSelectors.getCounters

export const getUsersCounters = hierarchyAssignmentsPanelTabSelectors.getUsersCounters

export const getPanelUserFirstName = hierarchyAssignmentsPanelTabSelectors.getPanelUserFirstName

export const getPanelUserFML = hierarchyAssignmentsPanelTabSelectors.getPanelUserFML

export const getPanelUser = hierarchyAssignmentsPanelTabSelectors.getPanelUser

export const selectTaskEntities = hierarchyAssignmentsPanelTabSelectors.selectTaskMaEntities

export const selectProjectEntities = hierarchyAssignmentsPanelTabSelectors.selectProjectMaEntities

export const selectCustomerEntities = hierarchyAssignmentsPanelTabSelectors.selectCustomerMaEntities

export const isLoading = hierarchyAssignmentsPanelTabSelectors.isLoading

export const isLoaded = hierarchyAssignmentsPanelTabSelectors.isLoaded

export const isPanelOpened = state => getEditManagementAssignmentsPanelState(state).userId !== null

export const getManagementAssignmentsSelection = state => getUserDataManagementAssignmentsSelection(state)

export const isShowArchivedEntities = hierarchyAssignmentsPanelTabSelectors.isShowArchivedEntities

export const isShown = createSelector(
    getUserId,
    (userId) => userId !== null
)

export const isNeedToLoadData = createSelector(
    isShown,
    isLoaded,
    getTab,
    loadedTabs,
    showEditor,
    (show, loaded, tab, loadedTabs, showEditor) => show === true && (loaded === false || loadedTabs[tab] === false) && showEditor === false
)

export const getEntirelyAssignedTasksCounter = createSelector(
    getTaskIds,
    getCounters,
    (ids, counters) => {
        return counters.tasks.curValue - ids.length
    }
)

export const getEntirelyAssignedProjectCounter = createSelector(
    getProjectIds,
    getCounters,
    (ids, counters) => {
        return counters.projects.curValue - ids.length
    }
)

export const isShowCopyContent = createSelector(
    getEditManagementAssignmentsPanelState,
    panelState => panelState.showCopyContent
)

export const getCopyContentState = createSelector(
    getEditManagementAssignmentsPanelState,
    panelState => panelState.copyContent
)

export const getCopyUserId = createSelector(
    getCopyContentState,
    copyContent => copyContent.userId
)

export const isCopyLoading = createSelector(
    getCopyContentState,
    copyContent => copyContent.loading
)

export const getCopyUserCounters = createSelector(
    getCopyContentState,
    copyContent => copyContent.counters
)

const _getSelectorsUsers = createSelector(
    getCopyContentState,
    copyContent => copyContent.usersForSelector
)

export const getSelectorsUsers = createSelector(
    _getSelectorsUsers,
    getUserId,
    (usersForSelector, userToId) => usersForSelector.filter(user => user.id !== userToId
                                                                         && canAccessManagersScope(user) && !canAccessAllManagementScope(user)
                                                                         && user.managementAssignmentsSelection === ManagementAssignmentsSelection.SELECTED)
)

export const getCopyUserFrom = createSelector(
    getCopyUserId,
    getSelectorsUsers,
    (id, users) => {
        const usersMap = arrayToMap(users)
        return usersMap[id]
    }
)

export const isUserHasSelectedScope = createSelector(
    getUsersCounters,
    counters => counters.tasks > 0
)


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/editManagementAssignmentsPanel/selectors.js